<div class="tab-container mat-typography compact-view">
  <div class="layout-row-wrap responsive-column compact-details condensed">
    <div class="flex-45 mat-body-strong left">{{ 'labels.inputs.Parent Office' | translate }}</div>
    <div class="flex-50 right">
      {{ officeData.parentName ? officeData.parentName : 'N/A' }}
    </div>
    <hr class="section-divider" />

    <div class="flex-45 mat-body-strong left">{{ 'labels.inputs.Opened On' | translate }}</div>
    <div class="flex-50 right">
      {{ officeData.openingDate ? (officeData.openingDate | dateFormat) : 'Unassigned' }}
    </div>
    <hr class="section-divider" />

    <div class="flex-45 mat-body-strong left">{{ 'labels.inputs.Name Decorated' | translate }}</div>
    <div class="flex-50 right">
      {{ officeData.nameDecorated ? officeData.nameDecorated : 'Unassigned' }}
    </div>
    <hr class="section-divider" />

    <div class="flex-45 mat-body-strong left">{{ 'labels.inputs.External Id' | translate }}</div>
    @if (officeData.externalId) {
      <div class="flex-50 right">
        <LOSx-external-identifier externalId="{{ officeData.externalId }}"></LOSx-external-identifier>
      </div>
    }
    @if (!officeData.externalId) {
      <div class="flex-50 right">
        {{ 'labels.inputs.Unassigned' | translate }}
      </div>
    }
  </div>

  <div class="bottom-button-container small-buttons">
    <span *LOSxHasPermission="'UPDATE_OFFICE'">
      <button mat-raised-button color="primary" [routerLink]="['../edit']" class="edit-button">
        <fa-icon icon="edit" class="m-r-5"></fa-icon>{{ 'labels.buttons.Edit' | translate }}
      </button>
    </span>
  </div>
</div>
